import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from './client';
import type { AmbitDocument, DocumentAdminDto } from './administracio';

/** Metadades editables d'un document (PUT /documents/{id}). */
export interface DocumentMetadadesDto {
  id: number;
  titol: string;
  categoria?: string | null;
  ambit: AmbitDocument;
  responsableId?: number | null;
}

/** Desa les metadades d'un document amb l'ETag de la lectura que va carregar el formulari. */
export function useDesaDocument(etag?: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (m: DocumentMetadadesDto) =>
      apiRequest<DocumentAdminDto>(`/documents/${m.id}`, {
        method: 'PUT',
        json: m,
        headers: etag ? { 'If-Match': etag } : undefined,
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['documents'] });
      void qc.invalidateQueries({ queryKey: ['etag'] });
      void qc.invalidateQueries({ queryKey: ['auditoria'] });
    },
  });
}

/** Torna a publicar un document retirat. */
export function useRestauraDocument() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) =>
      apiRequest<DocumentAdminDto>(`/documents/${id}/restaurar`, { method: 'POST' }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['documents'] });
      void qc.invalidateQueries({ queryKey: ['auditoria'] });
    },
  });
}
